import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import "./App.scss";
import CampaignDetails from "./components/CampaignDetails";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to="/:id" />,
    },
    {
      path: "/:id",
      element: <CampaignDetails />,
    },
  ]);
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
